import React, { useContext } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { UserContext } from "../App";
import Loading from "../components/Loading/Loading";

const RequiredAuth = ({ children }) => {
  let location = useLocation();
  const token = localStorage.getItem("token");
  const { user, loading } = useContext(UserContext);
  if (loading) {
    return <Loading></Loading>;
  } else {
    if (!token && !user) {
      return <Navigate to="/" state={{ from: location }} replace />;
    } else {
      if (user?.role === "admin") {
        return children;
      } else {
        return <Navigate to="/" state={{ from: location }} replace />;
      }
    }
  }
};

export default RequiredAuth;
